var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBurgerMenu = function SvgBurgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 512 512"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "\n    Menu\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M424 394H89a8 8 0 010-16h335a8 8 0 010 16zm0-129H89a8 8 0 010-16h335a8 8 0 010 16zm0-130H89a8 8 0 010-16h335a8 8 0 010 16z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })));
};
export default SvgBurgerMenu;